module.exports = "# Extension Activities\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/extensionActivities/extensionActivities.md
// module id = 1715
// module chunks = 2